<label for="" class="position-relative-trick" *ngIf="text">
  <div class="form__error u-mt10 position-absolute">
    {{text}}
  </div>
</label>
